/** Subtiele eenmalige peek op mobiele swipe-rij (onboarding swipeTeaser). */
export const SWIPE_TEASER_PEEK_ANIMATION =
  'swipeTeaserPeek 1.1s ease-in-out 1';

/** @returns {import('@mui/material').SxProps} */
export function getTaskItemSwipeTeaserSx() {
  return {
    '@keyframes swipeTeaserPeek': {
      '0%, 100%': { transform: 'translateX(0)' },
      '35%, 55%': { transform: 'translateX(14px)' },
    },
    animation: SWIPE_TEASER_PEEK_ANIMATION,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  };
}
